module.exports = __webpack_public_path__ + "static/media/BagelInset.b518ff1f.svg";